import { gql } from '@apollo/client';

export const GET_PLAYER_ASSESSMENT_REPORT_DATA = gql`
  query GetPlayerAssessmentReportData($playerAssessmentId: ID!, $token: String) {
    reportCardData(playerAssessmentId: $playerAssessmentId, token: $token) {
      _id
      data
      createdAt
      updatedAt
    }
  }
`;